import template from './tableGridRadioCell.html';
import controller from './tableGridRadioCell.controller';
import _ from 'lodash';

let tableGridRadioCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '=',
      metaData: '=',
      options: '='
    },
    template,
    controller,
    controllerAs: 'vm',
    link: (scope,elem,attrs,ctrl) => {
      scope.vm = scope;
      scope.vm.column = _.find(scope.columns, {
        name: scope.columnName
      });
      scope.vm.isSelected = ctrl.isSelected;
      scope.vm.isDisabled = ctrl.isDisabled;
    }
  };
};

export
default tableGridRadioCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridRadioCell/tableGridRadioCell.component.js